module.exports = __webpack_public_path__ + "img/footer-logo-ja.66063b7a.png";